import React from 'react'
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeCpvInput from "../../components/inputs/NoticeCpvInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";
import GridBlock from "components/GridBlock";



function NoticeObjectDividedList(
    {
        id,
        formikProps,
        index,
    }) {

    const gId = (name) => id + "." + name;

    return (<>
        <GridBlock justify="space-evenly">
            <NoticeTypography formTrKey={id}>: {index + 1}</NoticeTypography>
        </GridBlock>

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("orderSubjectDescription")}
            multiline
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("mainCpv")}
            required
        />

        <NoticeCpvInput
            formikProps={formikProps}
            id={gId("additionalCpv")}
            multiple
        />

    </>)
}

NoticeObjectDividedList.propTypes = {};

export default NoticeObjectDividedList;
